exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1{color:#fff}.goright{position:relative;right:460px}", ""]);

// exports
